import { render, staticRenderFns } from "./OrderNumberConfirmDialog.vue?vue&type=template&id=15be82d2&scoped=true"
import script from "./OrderNumberConfirmDialog.vue?vue&type=script&lang=js"
export * from "./OrderNumberConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderNumberConfirmDialog.vue?vue&type=style&index=0&id=15be82d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be82d2",
  null
  
)

export default component.exports